<template>
  <div class="material-container">
    <!-- 顶部导航和搜索部分 -->
    <div class="top-section">
      <div class="top-nav">
        <el-button
          v-for="(tab, index) in tabs"
          :key="index"
          :class="['nav-button', {'is-active': activeTab === tab.name}]"
          :type="activeTab === tab.name ? 'primary' : 'default'"
          @click="changeTab(tab.name)"
        >
          {{ tab.label }}
        </el-button>
      </div>

      <div class="search-section">
        <el-input
          :value="activeTab === 'category' ? searchKeyCategory : searchKeyParameter"
          @input="handleSearchInput"
          :placeholder="activeTab === 'category' ? '搜索材料名称' : '搜索产品名称、激光类别'"
          class="search-input"
        >
          <i slot="prefix" class="el-icon-search"></i>
        </el-input>
        <el-button type="primary" @click="activeTab === 'category' ? searchMaterials() : searchParameters()" class="search-button">搜索</el-button>
      </div>
    </div>

    <!-- 材料类别数据表格 -->
    <el-table
      v-if="activeTab === 'category'"
      :data="paginatedMaterials"
      stripe
      class="material-table"
    >
      <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
      <el-table-column prop="materialName" label="材料名称" align="center"></el-table-column>
      <el-table-column prop="materialThickness" label="材料厚度" align="center"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" align="center">
        <template #default="{ row }">
          {{ formatDate(row.updateTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template #default="{ row }">
          <el-button 
            type="primary" 
            size="mini" 
            class="view-params-btn"
            @click="handleProcessParams(row)">
            查看加工参数
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 参数库数据卡片 -->
    <div v-if="activeTab === 'parameter'" class="parameter-cards-container">
      <div class="parameter-cards">
        <div v-for="(item, index) in paginatedParameters" :key="index" class="parameter-card">
          <div class="card-id"><span style="color:#2EA2FA; ">ID:</span>{{ item.id }}</div>
          <div class="card-content">
            <div class="card-title"><span style="color:#2EA2FA;">产品名称:</span>{{ item.productName }}</div>
            <div class="card-body">
              <div class="card-image">
                <img 
                  :src="`/resources/productParameters/${item.productUrl}`" 
                  alt="产品示意图" 
                  class="product-image" 
                />
              </div>
              <div class="card-params">
                <div v-for="(param, pIndex) in item.processingParameters ? item.processingParameters.split(' ').slice(0, 3) : []" 
                     :key="pIndex" 
                     class="param-item">
                  {{ param }}
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="card-laser-type"><span style="color:#2EA2FA;">激光类别:</span>{{ item.laserCategory }}</div>
              <div class="card-update-time"><span style="color:#2EA2FA;">更新时间:</span>{{ formatDate(item.updateTime) }}</div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 参数库分页 -->
      <div class="pagination-container">
        <el-pagination
          v-if="paginationParameter.total > 0"
          :current-page="paginationParameter.page"
          :page-size="paginationParameter.pageSize"
          :total="paginationParameter.total"
          @current-change="handleParameterPagination"
          layout="total, prev, pager, next, jumper"
          background
        ></el-pagination>
      </div>
    </div>

    <!-- 分页组件 -->
    <div class="pagination-container">
      <el-pagination
        v-if="activeTab === 'category' && paginationCategory.total > 0"
        :current-page="paginationCategory.page"
        :page-size="paginationCategory.pageSize"
        :total="paginationCategory.total"
        @current-change="handleCategoryPagination"
        layout="total, prev, pager, next, jumper"
        background
      ></el-pagination>
    </div>

    <!-- 加工参数对话框 -->
    <el-dialog
      title="加工参数"
      :visible.sync="processParamsDialog"
      width="50%">
      <div class="process-params">
        <p>材料名称：{{ currentMaterial.materialName }}</p>
        <p>材料厚度：{{ currentMaterial.materialThickness }}</p>
        <p>加工参数：{{ currentMaterial.processingParameters }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="processParamsDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request';

export default {
  data() {
    return {
      activeTab: 'category', // 当前选中的标签
      tabs: [
        { name: 'category', label: '材料参数' },
        { name: 'parameter', label: '产品参数' }
      ],
      searchKeyCategory: '', // 材料类别搜索关键词
      searchKeyParameter: '', // 参数库搜索关键词
      materials: [], // 材料数据
      parameters: [], // 参数库数据
      paginationCategory: { page: 1, pageSize: 8, total: 0 }, // 材料类别分页
      paginationParameter: { page: 1, pageSize: 6, total: 0 }, // 参数库分页
      processParamsDialog: false, // 加工参数对话框显示控制
      currentMaterial: {}, // 当前选中的材料
      originalMaterials: [], // 保存原始材料数据用于搜索
      originalParameters: [] // 保存原始参数库数据用于搜索
    };
  },
  computed: {
    // 计算分页后的材料类别数据
    paginatedMaterials() {
      const start = (this.paginationCategory.page - 1) * this.paginationCategory.pageSize;
      const end = start + this.paginationCategory.pageSize;
      return this.materials.slice(start, end);
    },
    // 计算分页后的参数库数据
    paginatedParameters() {
      const start = (this.paginationParameter.page - 1) * this.paginationParameter.pageSize;
      const end = start + this.paginationParameter.pageSize;
      return this.parameters.slice(start, end);
    }
  },
  methods: {
    changeTab(tab) {
      this.activeTab = tab; // 切换标签时，重置到第一页
      if (tab === 'category') {
        this.paginationCategory.page = 1; // 重置分页
      } else {
        this.paginationParameter.page = 1; // 重置分页
      }
    },
    searchMaterials() {
      if (!this.searchKeyCategory) {
        this.materials = [...this.originalMaterials];
        this.paginationCategory.total = this.materials.length;
        this.paginationCategory.page = 1;
        return;
      }

      const filteredData = this.originalMaterials.filter(item => 
        (item.materialName && item.materialName.toLowerCase().includes(this.searchKeyCategory.toLowerCase())) ||
        (item.materialThickness && item.materialThickness.toString().includes(this.searchKeyCategory))
      );
      this.materials = filteredData;
      this.paginationCategory.total = filteredData.length;
      this.paginationCategory.page = 1;
    },
    searchParameters() {
      if (!this.searchKeyParameter) {
        this.parameters = [...this.originalParameters];
        this.paginationParameter.total = this.parameters.length;
        this.paginationParameter.page = 1;
        return;
      }

      const filteredData = this.originalParameters.filter(item => 
        (item.productName && item.productName.toLowerCase().includes(this.searchKeyParameter.toLowerCase())) ||
        (item.laserCategory && item.laserCategory.toLowerCase().includes(this.searchKeyParameter.toLowerCase()))
      );
      this.parameters = filteredData;
      this.paginationParameter.total = filteredData.length;
      this.paginationParameter.page = 1;
    },
    handleCategoryPagination(page) {
      this.paginationCategory.page = page; // 更新当前页码
    },
    handleParameterPagination(page) {
      this.paginationParameter.page = page; // 更新当前页码
    },
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    // 处理加工参数按钮点击
    handleProcessParams(row) {
      this.currentMaterial = row;
      this.processParamsDialog = true;
    },
    // 获取材料数据
    fetchMaterialData() {
      console.log('正在获取材料数据...');
      request.get('/api/materialWarehouse/selectAll')
        .then(response => {
          console.log('材料数据响应:', response);
          if (response.code === 0 && response.data) {
            this.materials = response.data.map(item => ({
              id: item.id,
              materialName: item.materialName || item.devidName,
              materialThickness: item.materialThickness || item.deviceNumber,
              updateTime: item.updateTime || item.createTime,
              processingParameters: item.processingParameters || ''
            }));
            this.originalMaterials = [...this.materials]; // 保存原始数据
            this.paginationCategory.total = this.materials.length;
            console.log('处理后的材料数据:', this.materials);
          } else {
            console.error('获取材料数据失败:', response.msg);
            this.$message.error(response.msg || '获取材料数据失败');
          }
        })
        .catch(error => {
          console.error('获取材料数据请求失败:', error);
          this.$message.error(error.message || '获取材料数据失败');
        });
    },
    // 获取参数库数据
    fetchParametersData() {
      console.log('正在获取参数库数据...');
      request.get('/api/productParameters/selectAll')
        .then(response => {
          console.log('参数库数据响应:', response);
          if (response.code === 0 && response.data) {
            this.parameters = response.data.map(item => ({
              id: item.id,
              productName: item.productName,
              laserCategory: item.laserCategory,
              productUrl: item.productUrl,
              processingParameters: item.processingParameters,
              updateTime: item.updateTime
            }));
            this.originalParameters = [...this.parameters]; // 保存原始数据
            this.paginationParameter.total = this.parameters.length;
            console.log('处理后的参数库数据:', this.parameters);
          } else {
            console.error('获取参数库数据失败:', response.msg);
            this.$message.error(response.msg || '获取参数库数据失败');
          }
        })
        .catch(error => {
          console.error('获取参数库数据请求失败:', error);
          this.$message.error(error.message || '获取参数库数据失败');
        });
    },
    handleSearchInput(val) {
      if (this.activeTab === 'category') {
        this.searchKeyCategory = val;
        if (!val) {
          this.materials = [...this.originalMaterials];
          this.paginationCategory.total = this.materials.length;
          this.paginationCategory.page = 1;
        }
      } else {
        this.searchKeyParameter = val;
        if (!val) {
          this.parameters = [...this.originalParameters];
          this.paginationParameter.total = this.parameters.length;
          this.paginationParameter.page = 1;
        }
      }
    }
  },
  created() {
    // 组件创建时获取数据
    console.log('组件创建，开始获取数据');
    this.fetchMaterialData();
    this.fetchParametersData();
  }
};
</script>

<style scoped>
.material-container {
  padding: 20px;
  background-color: #ffffff;
  min-height: calc(100vh - 60px);
  border-radius: 20px;
}

.top-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 8px;
  padding: 10px;
}

.top-nav {
  display: flex;
  margin-right: 20px;
}

.nav-button {
  margin-right: 10px;
  border-radius: 10px;
  font-size: 16px;
  padding: 10px 20px;
  width: 200px;
  height: 67px;
  color: #2EA2FA;
  border: 2px solid rgba(46, 162, 250, 1);
  padding: 14px 20px 14px 20px;
}

.nav-button.is-active {
  background: rgba(46, 162, 250, 1);
  box-shadow: 2px 2px 10px  rgba(46, 162, 250, 1);
  color: white !important;
  border: none;
}

.search-section {
  display: flex;
  align-items: center;
}

.search-input {
  width: 300px;
  margin-right: 10px;
  border-radius: 4px;
  background-color: #F2F2F2 !important;
}

.search-input :deep(.el-input__prefix) {
  display: flex;
  align-items: center;
  border-radius: 20px;
}

.search-button {
  background-color: #409EFF;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
}

.material-table {
  width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.material-table :deep(th) {
  background-color: #E5F4FF !important;
  color: #333;
  font-weight: bold;
  font-size: 20px;
  padding: 12px 0;
}

.material-table :deep(td) {
  padding: 12px 0;
}

.view-params-btn {
  background-color: #409EFF;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
}

.parameter-cards-container {
  margin-bottom: 20px;
  padding: 0 10px;
}

.parameter-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.parameter-card {
  margin: 15px;
  width: calc(33.33% - 30px);
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.15);
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  padding-bottom: 10px;
}

.card-id {
  position: absolute;
  top: 10px;
  left: 15px;
  font-size: 18px;
  font-weight: normal;
  color: #333;
}

.card-id span {
  margin-right: 5px;
}

.card-content {
  padding: 40px 15px 10px;
}

.card-title {
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 15px;
  text-align: left;
}

.card-title span {
  margin-right: 5px;
}

.card-body {
  display: flex;
  margin-bottom: 15px;
  align-items: flex-start;
}

.card-image {
  width: 140px;
  height: 100px;
  margin-right: 15px;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
  background-color: #F3FAFF;
}

.card-params {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 5px;
}

.param-item {
  margin: 2px 0;
  font-size: 12px;
  padding: 4px 10px;
  background-color: #E5F4FF;
  border-radius: 4px;
  color: rgba(51, 51, 51, 1);
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  text-align: center;
}

.param-item:hover {
  background-color: #D0E8FF;
}

.card-footer {
  padding: 10px;
 
  display: flex;
  flex-direction: column;
  gap: 5px;
  text-align: left;
}

.card-laser-type, .card-update-time {
  font-size: 18px;
  color: #333;
  display: flex;
}

.card-laser-type span, .card-update-time span {
  color: #2EA2FA;
  margin-right: 5px;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
}

.process-params {
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 4px;
  line-height: 1.8;
}

/* 媒体查询，适配不同屏幕尺寸 */
@media screen and (max-width: 1200px) {
  .parameter-card {
    width: calc(50% - 30px);
  }
}

@media screen and (max-width: 768px) {
  .parameter-card {
    width: calc(100% - 30px);
  }
  
  .search-input {
    width: 200px;
  }
  
  .nav-button {
    padding: 8px 15px;
    font-size: 14px;
    width: auto;
  }
}
</style>
